    document.querySelectorAll("[data-vd-routine-builder]").forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = "true";

      const panel = root.querySelector('[data-vd-builder-panel]');
      const openButton = root.querySelector('[data-vd-builder-open]');
      const productData = JSON.parse(root.querySelector('[data-vd-routine-products]').textContent);
      const products = new Map(productData.map((product) => [product.key, product]));
      const order = ['oil', 'foam', 'toner', 'serum', 'cream'];
      const inputs = Array.from(root.querySelectorAll('.vd-quiz-check input'));
      const resultTitle = root.querySelector('[data-result-title]');
      const resultCopy = root.querySelector('[data-result-copy]');
      const resultProducts = root.querySelector('[data-result-products]');
      const addButton = root.querySelector('[data-add-routine]');
      const submitButton = root.querySelector('[data-submit-answers]');
      const answerStatus = root.querySelector('[data-answer-status]');
      const status = root.querySelector('[data-result-status]');
      const dots = new Map(order.map((key) => [key, root.querySelector(`[data-meter-dot="${key}"]`)]));
      let currentKeys = [];
      let hasSubmitted = false;
      let offers = null;
      let selectionQuote = null;
      let requestVersion = 0;
      let adding = false;
      const summary = root.querySelector('[data-selection-summary]');
      const help = root.querySelector('[data-selection-help]');
      const escape = text => String(text).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
      function updateSelection() {
        currentKeys = [...resultProducts.querySelectorAll('input:checked')].map(input => input.value);
        dots.forEach((dot, key) => dot?.classList.toggle('is-active', currentKeys.includes(key)));
        if (!offers) return;
        selectionQuote = VeriOffers.quote(currentKeys, productData, offers);
        const q = selectionQuote;
        const currency = window.Shopify?.currency?.active || 'USD';
        summary.hidden = false;
        summary.innerHTML = `<span>${q.selected.length} ${q.selected.length === 1 ? 'product' : 'products'} selected</span><strong>${VeriOffers.money(q.total)} ${currency}</strong>` +
          (q.saving ? `<p><s>${VeriOffers.money(q.regular)}</s> · Save ${VeriOffers.money(q.saving)}</p><p>${q.offers.map(offer => escape(offer.name)).join(' + ')}</p>` : '<p>Regular product prices</p>') +
          (currency === 'USD' && q.total >= 10000 ? '<p>Qualifies for free standard shipping.</p>' : '<p>Free standard shipping on orders of $100 USD or more after discounts.</p>');
        addButton.textContent = q.selected.length ? `Add ${q.selected.length === 1 ? 'product' : 'selection'} · ${VeriOffers.money(q.total)}` : 'Choose at least one product';
        addButton.disabled = adding || !q.selected.length;
      }
      resultProducts.addEventListener('change', () => { updateSelection(); if(selectionQuote)window.VeriTrack?.('quiz_selection_updated',{item_count:selectionQuote.selected.length,value:selectionQuote.total/100,currency:Shopify.currency.active}); });

      const matchRules = {
        tight: [
          {
            key: 'foam',
            reason: 'You selected tight after cleansing, so this is the cleanser swap: a gentle daily foam that cleans without leaving skin feeling bare.'
          }
        ],
        redness: [
          {
            key: 'serum',
            reason: 'You selected visible redness, so this adds the most focused Centella comfort step.'
          }
        ],
        dehydrated: [
          {
            key: 'toner',
            reason: 'You selected dry by afternoon, so this adds a light hydration layer after cleansing.'
          },
          {
            key: 'cream',
            reason: 'You selected dry by afternoon, so this seals hydration to help comfort last longer.'
          }
        ],
        dull: [
          {
            key: 'toner',
            reason: 'You selected dull or uneven texture, so this preps skin with hydration for a smoother-feeling routine.'
          }
        ],
        spf: [
          {
            key: 'oil',
            reason: 'You selected daily SPF, so this first cleanse helps dissolve sunscreen before your regular cleanse.'
          }
        ],
        makeup: [
          {
            key: 'oil',
            reason: 'You selected makeup or long-wear SPF, so this oil cleanse breaks down heavier wear first.'
          },
          {
            key: 'foam',
            reason: 'You selected makeup or long-wear SPF, so this follows with a gentle water cleanse.'
          }
        ],
        actives: [
          {
            key: 'cream',
            reason: 'You selected actives, so this gives the barrier a cushioned sealing step around stronger products.'
          }
        ],
        stress: [
          {
            key: 'serum',
            reason: 'You selected barrier stress, so this adds a focused Centella layer for a calmer-feeling routine.'
          },
          {
            key: 'cream',
            reason: 'You selected barrier stress, so this seals the routine with a steady comfort layer.'
          }
        ]
      };

      const fullRitualReasons = {
        oil: 'You asked for the full ritual, so this starts the routine by dissolving sunscreen, makeup, and daily buildup.',
        foam: 'You asked for the full ritual, so this follows with the water-based cleanse.',
        toner: 'You asked for the full ritual, so this preps skin with a light hydration layer.',
        serum: 'You asked for the full ritual, so this adds the focused Centella treatment step.',
        cream: 'You asked for the full ritual, so this seals the routine with a final comfort layer.'
      };

      function getSelected() {
        return inputs.filter((input) => input.checked);
      }

      function addRecommendation(recommendations, key, reason) {
        if (!products.has(key)) return;
        if (!recommendations.has(key)) recommendations.set(key, []);
        const reasons = recommendations.get(key);
        if (!reasons.includes(reason)) reasons.push(reason);
      }

      function getSimplePriority(selectedValues) {
        const priority = [];
        const add = (key) => {
          if (!priority.includes(key)) priority.push(key);
        };

        if (selectedValues.has('makeup')) {
          add('oil');
          add('foam');
        } else if (selectedValues.has('spf')) {
          add('oil');
        }

        if (selectedValues.has('tight')) add('foam');
        if (selectedValues.has('redness') || selectedValues.has('stress')) add('serum');
        if (selectedValues.has('dehydrated') || selectedValues.has('dull')) add('toner');
        if (selectedValues.has('dehydrated') || selectedValues.has('stress') || selectedValues.has('actives')) add('cream');

        order.forEach(add);
        return priority;
      }

      function getRoutine() {
        const selected = getSelected();
        const selectedValues = new Set(selected.map((input) => input.value));
        const recommendations = new Map();

        selected.forEach((input) => {
          (matchRules[input.value] || []).forEach((match) => {
            addRecommendation(recommendations, match.key, match.reason);
          });
        });

        if (selectedValues.has('full')) {
          order.forEach((key) => addRecommendation(recommendations, key, fullRitualReasons[key]));
        }

        let keys = order.filter((key) => recommendations.has(key));

        if (selectedValues.has('simple') && !selectedValues.has('full') && keys.length > 3) {
          const keep = new Set(getSimplePriority(selectedValues).filter((key) => recommendations.has(key)).slice(0, 3));
          keys = order.filter((key) => keep.has(key));
        }

        const summaries = selected
          .filter((input) => !input.dataset.mode)
          .map((input) => input.dataset.summary)
          .filter(Boolean)
          .slice(0, 4);

        if (!keys.length) {
          return {
            title: 'No product match yet',
            copy: 'Choose at least one skin need, not only a routine length, so we can recommend products with a real reason.',
            keys,
            reasons: recommendations
          };
        }

        let title = 'Your targeted routine';

        if (selectedValues.has('full') || keys.length === 5) {
          title = 'Full Centella Ritual';
        } else if (keys.length === 1) {
          title = 'Your focused match';
        } else if (keys.includes('oil') && keys.includes('foam')) {
          title = 'Your double-cleanse match';
        } else if (keys.length === 2) {
          title = 'Your targeted pair';
        }

        const productWord = keys.length === 1 ? 'product' : 'products';
        let copy = keys.length === 1
          ? 'One selected need, one focused product. Nothing extra added.'
          : `${keys.length} ${productWord} matched to your selected needs.`;

        if (selectedValues.has('full')) {
          copy = 'You asked for the full ritual, so all five products are included in step order.';
        } else if (selectedValues.has('simple')) {
          copy = `${copy} Kept simple as requested.`;
        }

        if (summaries.length) {
          copy = `${copy} Chosen for: ${summaries.join(', ')}.`;
        }

        return { title, copy, keys, reasons: recommendations };
      }

      function renderEmpty(message) {
        currentKeys = [];
        requestVersion++;
        summary.hidden = true;
        help.hidden = true;
        resultTitle.textContent = 'Your routine will appear here';
        resultCopy.textContent = message || 'Choose the skin notes that feel familiar, then submit your answers. We will only suggest products after you tell us what your skin needs.';
        resultProducts.innerHTML = '';
        dots.forEach((dot) => {
          if (dot) dot.classList.remove('is-active');
        });
        if (addButton) {
          addButton.hidden = true;
          addButton.disabled = true;
        }
      }

      async function renderRoutine(routine = getRoutine()) {
        if (!routine.keys.length) { renderEmpty(routine.copy); return; }
        const version = ++requestVersion;
        resultTitle.textContent = routine.title;
        resultCopy.textContent = routine.copy;
        help.hidden = false;
        addButton.hidden = false;
        addButton.disabled = true;
        addButton.textContent = 'Checking current offers…';
        resultProducts.innerHTML = order.map(key => {
          const product = products.get(key);
          const recommended = routine.keys.includes(key);
          const reason = recommended ? (routine.reasons.get(key) || [product.reason]).slice(0, 2).join(' ') : product.reason;
          return `<article class="vd-quiz-product${recommended ? ' is-recommended' : ''}">
            <img src="${escape(product.image)}" alt="" loading="lazy" width="80" height="80">
            <div class="vd-quiz-product__meta">
              <label class="vd-quiz-include"><input type="checkbox" value="${key}" ${recommended && product.available ? 'checked' : ''} ${product.available ? '' : 'disabled'}><span>Include ${escape(product.title)}</span></label>
              <span>${product.step} ${escape(product.role)} · ${escape(product.price)}${product.available ? '' : ' · Sold out'}</span>
              <p>${escape(reason)}</p><a href="${escape(product.url)}">Product details &amp; ingredients</a>
            </div></article>`;
        }).join('');
        try {
          offers = await VeriOffers.load(productData);
          if (version !== requestVersion) return;
          status.textContent = '';
          updateSelection();
          window.VeriTrack?.('quiz_completed',{item_count:selectionQuote.selected.length,value:selectionQuote.total/100,currency:Shopify.currency.active});
          if (matchMedia('(max-width: 699px)').matches) resultTitle.scrollIntoView({behavior:'smooth',block:'start'});
        } catch (error) {
          if (version !== requestVersion) return;
          addButton.textContent = 'Offers temporarily unavailable';
          status.textContent = 'We could not check the current offers. Submit your answers again to retry, or use the product links above.';
        }
      }

      openButton?.addEventListener('click', () => {
        const willOpen = panel.hasAttribute('hidden');
        panel.toggleAttribute('hidden', !willOpen);
        root.classList.toggle('is-open', willOpen);
        openButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

        if (willOpen) {
          window.setTimeout(() => {
            panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 80);
        }
      });

      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (input.dataset.mode === 'simple' && input.checked) {
            const full = inputs.find((item) => item.dataset.mode === 'full');
            if (full) full.checked = false;
          }

          if (input.dataset.mode === 'full' && input.checked) {
            const simple = inputs.find((item) => item.dataset.mode === 'simple');
            if (simple) simple.checked = false;
          }

          hasSubmitted = false;
          if (answerStatus) answerStatus.textContent = 'Answers changed. Submit again to refresh your routine.';
          status.textContent = '';
          renderEmpty('Your answers changed. Submit them when you are ready, and your recommended routine will appear here.');
        });
      });

      submitButton?.addEventListener('click', () => {
        if (!getSelected().length) {
          if (answerStatus) answerStatus.textContent = 'Choose at least one skin note first.';
          status.style.color = '#994f34';
          status.textContent = 'We need one answer before suggesting products.';
          renderEmpty('Select at least one note that sounds like your skin. We will keep the product recommendation empty until then.');
          return;
        }

        const routine = getRoutine();

        if (!routine.keys.length) {
          hasSubmitted = false;
          if (answerStatus) answerStatus.textContent = 'Add one skin need before we recommend products.';
          status.style.color = '#994f34';
          status.textContent = 'Routine length alone is not enough to choose products.';
          renderEmpty(routine.copy);
          return;
        }

        hasSubmitted = true;
        if (answerStatus) answerStatus.textContent = 'Routine matched.';
        status.style.color = '#233d32';
        status.textContent = '';
        renderRoutine(routine);
      });

      addButton?.addEventListener('click', async () => {
        if (!hasSubmitted || !selectionQuote?.selected.length || adding) return;
        adding = true;
        addButton.disabled = true;
        addButton.textContent = 'Adding selection…';
        resultProducts.querySelectorAll('input').forEach(input => input.disabled = true);
        try {
          await VeriOffers.add(selectionQuote);
          window.VeriTrack?.('quiz_cart_added',{item_count:selectionQuote.selected.length,value:selectionQuote.total/100,currency:Shopify.currency.active});
          status.style.color = '#233d32';
          status.innerHTML = 'Your selection was added. <a href="' + (window.Shopify?.routes?.root || '/') + 'cart">View cart and checkout</a>.';
          const cart = document.querySelector('cart-drawer');
          if (cart?.show) cart.show();
        } catch (error) {
          status.style.color = '#994f34';
          status.textContent = error.message || 'Could not add your selection. Please try again.';
        } finally {
          adding = false;
          resultProducts.querySelectorAll('input').forEach(input => input.disabled = !products.get(input.value)?.available);
          updateSelection();
        }
      });

      renderEmpty();
    });
